export enum CAMPAIGN_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
